import {
  styled,
  TextField,
  Autocomplete,
  autocompleteClasses,
} from "@mui/material";
import { Controller } from "react-hook-form";
import type { SyntheticEvent } from "react";

const StyledTextField = styled(TextField)`
  .Mui-error {
    text-align: right;
  }

  .MuiFormHelperText-root {
    text-align: right;
  }
`;

interface AutocompleteFieldCustomProps {
  id: string;
  label: string;
  control: any;
  options: string[];
  helperText?: string;
  disabled?: boolean;
}

export const AutocompleteFieldCustom = ({
                                          id,
                                          label,
                                          control,
                                          options,
                                          helperText = "",
                                          disabled = false,
                                        }: AutocompleteFieldCustomProps) => {
  return (
    <Controller
      name={id}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete<string, false, false, true>
          freeSolo
          disableClearable={false}
          options={options}
          value={field.value || ""}
          onChange={(_: SyntheticEvent, newValue: string | null) =>
            field.onChange(newValue)
          }
          onInputChange={(_: SyntheticEvent, newInputValue: string) =>
            field.onChange(newInputValue)
          }
          openOnFocus={false}
          disabled={disabled}
          slotProps={{
            popper: {
              placement: "bottom-start",
              modifiers: [{ name: "flip", enabled: false }],
              sx: {
                [`& .${autocompleteClasses.listbox}`]: {
                  direction: "rtl",
                  textAlign: "right",
                },
              },
            },
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              {...field}
              error={!!error}
              color="secondary"
              helperText={error ? error.message : helperText}
              label={label}
              variant="standard"
              InputProps={{
                ...params.InputProps,
                style: { textAlign: "right" },
              }}
              inputProps={{
                ...params.inputProps,
                style: { direction: "rtl" },
              }}
              InputLabelProps={{
                style: {
                  textAlign: "right",
                  position: "absolute",
                  right: "0",
                  width: "100%",
                  direction: "rtl",
                  color: "black",
                  transform: "unset",
                },
              }}
            />
          )}
        />
      )}
    />
  );
};
